export default __webpack_public_path__ + "static/media/Nunito-Italic.69cfa43a.ttf";